import React from "react";
import {
  Button,
  Divider,
  Drawer,
  FormFieldSet,
  useFormHandler,
} from "../../../../../components";
import AllDashboard from "../AllDashboard";
import { useNavigate } from "react-router-dom";
import { joiningTypeOptions } from "../../../../../assets/data/enumData";

const JoinOnboardingDrawer = ({
  isJoinOnboardingDrawerOpen,
  setIsJoinOnboardingDrawerOpen,
  handleSubmit,
  onClose
}) => {
  const navigate = useNavigate();
  const initialFormData = {
    dateOfJoining: "",
    joiningType: "",
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, {
      dateOfJoining: { type: "text", required: true },
    });

  return (
    <Drawer
      isOpen={isJoinOnboardingDrawerOpen}
      closeOnOutsideClick
      onClose={() => {
        setIsJoinOnboardingDrawerOpen(false);
        setFormData(initialFormData);
        onClose();
      }}
      position="right"
      width="w-[50%]"
      title={"Join Onboarding"}
    >
      <div className="flex flex-col justify-between h-full">
        <div className="flex flex-col gap-5">
          <FormFieldSet
            type="datepicker"
            title="Date of Joining"
            required
            placeholder="Date Of Joining"
            value={formData.dateOfJoining}
            onChange={(value) => handleChange("dateOfJoining", value)}
            error={errors.dateOfJoining}
            showDropdown={false}
          />
          {/* <FormFieldSet
            type="select"
            title="Joining Type"
            placeholder="Select Joining Type"
            options={joiningTypeOptions}
            value={formData.joiningType}
            onChange={(value) => handleChange("joiningType", value)}
            error={errors.joiningType}
            required
          />*/}
        </div>
        <div className="flex flex-col items-start justify-start gap-5">
          <Divider />
          <div className="flex  gap-5">
            <Button
              title={"Proceed"}
              //   onClick={() =>
              //     navigate(
              //       "/e-onboarding?e-onboarding=0&e-onboarding-dashboard=6"
              //     )
              //   }
              onClick={()=>handleSubmit(formData,validateAllFields)}
            />
            <Button
              title={"Cancel"}
              variant="outlined"
              onClick={() => {
                setFormData(initialFormData);
                setIsJoinOnboardingDrawerOpen(false);
                onClose();
              }}
            />
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default JoinOnboardingDrawer;
